import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCreateActivityLog } from '~/api/activity_logs_queries';
import { useCommonAppContext } from '~/shared/contexts/CommonAppContext';

const sitesToTrack = ['harmony', 'harmonyparts'];

// utils around tracking activity logs and reporting
export default function useActivityReportingOnLocationChange() {
  const location = useLocation()
  const { currentSite } = useCommonAppContext()
  const createActivityLogQuery = useCreateActivityLog()

  // runs on location change, every page
  useEffect(() => {

    if (!currentSite) return;
    if (!sitesToTrack.includes(currentSite.name)) return;

    // timeout allows for title to update
    // and also makes sure they spend some time on the page
    setTimeout(() => {
      createActivityLogQuery.mutateAsync({
        kind: 'page_view',
        data: {
          page_title: document.title,
          page_url: window.location.href,
        }
      })
    }, 1000);
  }, [location]);

  return null
}; 